module.exports = __webpack_public_path__ + "img/901525718.12e2964b.png";